<template>
    <div class="modal fade " id="sendProductArtworkToCustomer">
        <div class="modal-dialog  modal-dialog-centered modal-md modal-dialog-scrollable">
            <div class="modal-content">

                <!-- Modal Header -->
                <div class="modal-header bg-soft-info">
                    <h5 class="modal-title">Send Artwork To Customer</h5>
                    <button type="button" class="close" data-dismiss="modal"><i  class="ri-close-line"></i></button>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                    <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                        <ul>
                            <li v-for="(v, k) in commonErrors" :key="k">
                                <p v-for="error in v" :key="error" class="text-sm">
                                    {{ error }}
                                </p>
                            </li>
                        </ul>
                    </div>

                    <div class="form-group">
                        <label>Customer email address:</label><br>
                        <span class="text-primary" v-if="customer_contact">{{ customer_contact.email}} </span>
                        <span class="text-primary" v-else-if="order.customer">{{order.customer && order.customer.customer_contacts && order.customer.customer_contacts.length ? order.customer.customer_contacts[0].email : null}}</span>
                        <CustomerSelect :customer="order.customer" :multiple="true" @customerSelectedEvent="customerSelected"></CustomerSelect>
                    </div>
                    <div class="form-group">
                        <label for="subject">Subject</label>
                        <input type="text" class="form-control" id="subject" placeholder="" v-model="subject">

                        <div class="d-flex justify-content-between mt-1">
                            <a href="javascript:void(0);" class="badge badge-soft-primary fs-13" id="addCC" v-on:click="toggleCC"><span class="lt-bl-bg"> {{isCC ? 'Remove CC' : 'Add CC'}}</span></a>
                            <a href="javascript:void(0);" class="badge badge-soft-primary fs-13" id="addBCC" v-on:click="toggleBCC"><span class="lt-bl-bg"> {{isBCC ? 'Remove BCC' : 'Add BCC'}}</span></a>
                        </div>
                    </div>

                    <div class="form-group" v-if="isCC == true">
                        <label for="cc">CC</label>
                        <!--<input type="email" class="form-control" id="cc" placeholder="cc" v-model="cc">-->
                        <InputTag v-model="cc" id="cc" placeholder="Comma separated CC email addresses"
                                  :add-tag-on-blur="true"
                                  validate="email" :add-tag-on-keys="[9,13, 32, 188]"
                        ></InputTag>
                    </div>


                    <div class="form-group" v-if="isBCC == true">
                        <label for="bcc">BCC</label>
                        <!--<input type="email" class="form-control" id="bcc" placeholder="bcc" v-model="bcc">-->
                        <InputTag v-model="bcc" id="bcc" placeholder="Comma separated BCC email addresses"
                                  :add-tag-on-blur="true"
                                  validate="email" :add-tag-on-keys="[9,13, 32, 188]"
                        ></InputTag>
                    </div>


                    <div class="form-group textarea-box1">
                        <!--<label for="message_body">Hello</label>-->
                        <ckeditor v-model="message_body"
                                  tag-name="textarea"
                                  value="Hello, <p>Please Enter Message</p>"
                                  :config="editorConfigMin"></ckeditor>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <label for="attach">Add Attachment</label> <br>
                            <vue-dropzone :options="dropzoneOptions"
                                          :id="'item-dropzone-attach'"
                                          ref="sendArtToCustomerDropzone"
                                          v-on:vdropzone-success="(file, response) => afterUploadComplete(file, response)">
                            </vue-dropzone>
                        </div>

                        <div class="col-12" v-if="customer_files.length > 0">
                            <template v-for="(item, index) in customer_files">
                                <div class="pdf-dwn-sec line-hgt" :class="'vendor_num_' + index">
                                    {{item.name}}
                                    <span class="orderbtnsec">
                                        <a :href="item.src" target="_blank">
                                            Download</a>
                                    </span>
                                    <a href="javascript:void(0)" class="trash_btn"
                                       @click="deleteAttachFile(index, item)"><i class="fa fa-trash-alt fa-pull-right"></i></a>
                                </div>
                            </template>
                        </div>

                        <div class="col-12">
                            <template v-if="is_one_artwork_for_all && order.latest_artwork && order.latest_artwork.attach_link">
                                <div class="pdf-dwn-sec line-hgt">
                                    {{order.latest_artwork.attach_link}}
                                    <span class="orderbtnsec">
                                        <a href="javascript:void(0)" v-on:click="download(order.latest_artwork)">
                                            Download</a>
                                    </span>
                                </div>
                            </template>

                            <template v-if="is_one_artwork_for_all == false && product != null && product.latest_artwork && product.latest_artwork.attach_link">
                                <div class="pdf-dwn-sec line-hgt">
                                    {{product.latest_artwork.attach_link}}
                                    <span class="orderbtnsec">
                                        <a href="javascript:void(0)" v-on:click="download(product.latest_artwork)">
                                            Download</a>
                                    </span>
                                </div>
                            </template>

                            <template v-if="is_one_artwork_for_all == false && product == null">
                                <template v-if="po == null">
                                    <template v-for="(product1, index) in order.products">
                                        <div class="pdf-dwn-sec line-hgt" v-if="product1.latest_artwork && product1.latest_artwork.attach_link">
                                            <div class="custom-control custom-checkbox">
                                                <input type="checkbox" class="custom-control-input"
                                                       :value="product1.latest_artwork"
                                                       :id="'id_' +index"
                                                       v-model="artworks"
                                                       name="uns_prod_ids[]">
                                                <label class="custom-control-label" :for="'id_' +index">{{product1.latest_artwork.attach_link}}</label>
                                            </div>

                                            <span class="orderbtnsec">
                                                <a href="javascript:void(0)" v-on:click="download(product1.latest_artwork)">
                                                    Download</a>
                                            </span>
                                        </div>
                                    </template>
                                </template>
                                <template v-if="po != null">
                                    <template v-for="(product1, index) in po.products">
                                        <div class="pdf-dwn-sec line-hgt" v-if="product1.latest_artwork && product1.latest_artwork.attach_link">
                                            <div class="custom-control custom-checkbox">
                                                <input type="checkbox" class="custom-control-input"
                                                       :value="product1.latest_artwork"
                                                       :id="'id_' +index"
                                                       v-model="artworks"
                                                       name="uns_prod_ids[]">
                                                <label class="custom-control-label" :for="'id_' +index">{{product1.latest_artwork.attach_link}}</label>
                                            </div>

                                            <span class="orderbtnsec">
                                                <a href="javascript:void(0)" v-on:click="download(product1.latest_artwork)">
                                                    Download</a>
                                            </span>
                                        </div>
                                    </template>
                                </template>

                            </template>

                            <!--<template v-if="is_one_artwork_for_all == false && product == null">
                                <template v-for="(product1, index) in order.products">
                                    <div class="pdf-dwn-sec line-hgt" v-if="product1.latest_artwork && product1.latest_artwork.attach_link">
                                        {{product1.latest_artwork.attach_link}}
                                        <span class="orderbtnsec">
                                        <a href="javascript:void(0)" v-on:click="download(product1.latest_artwork)">
                                            Download</a>
                                    </span>
                                    </div>
                                </template>
                            </template>-->
                        </div>

                    </div>

                    <div class="mt-3">
                    <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary close-modal" v-on:click="sendToCustomer">Send Mail</button>
                    </div>

                </div>



            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import InputTag from "vue-input-tag";
import CustomerSelect from "./CustomerSelect";

export default {
    name: "SendProductArtworkToCustomer",
    components: {
        DatePicker,
        vueDropzone: vue2Dropzone,
        InputTag,
        CustomerSelect
    },
    props: ['order', 'product', 'artwork', 'is_one_artwork_for_all', 'po', 'customer_contact'],
    created() {

    },
    beforeMount() {
        this.getSendToCustomerSettings();
    },
    mounted() {
        let self = this;
        $('#sendProductArtworkToCustomer').on('hidden.bs.modal', function () {
            self.getSendToCustomerSettings();
        });

        $('#sendProductArtworkToCustomer').on('show.bs.modal', function () {
            self.artworks = [];
            if(self.po) {
                if(self.is_one_artwork_for_all && self.order.latest_artwork && self.order.latest_artwork.attach_link) {
                    self.artworks.push(self.order.latest_artwork);
                } else if(!self.is_one_artwork_for_all && self.product != null && self.product.latest_artwork && self.product.latest_artwork.attach_link) {
                    self.artworks.push(self.product.latest_artwork);
                } else if(!self.is_one_artwork_for_all && self.product == null) {
                    self.po.products.filter((product) => product.latest_artwork && product.latest_artwork.attach_link).forEach((product) => {
                        self.artworks.push(product.latest_artwork);
                    });
                }
            } else {
                if(self.is_one_artwork_for_all && self.order.latest_artwork && self.order.latest_artwork.attach_link) {
                    self.artworks.push(self.order.latest_artwork);
                } else if(!self.is_one_artwork_for_all && self.product != null && self.product.latest_artwork && self.product.latest_artwork.attach_link) {
                    self.artworks.push(self.product.latest_artwork);
                } else if(!self.is_one_artwork_for_all && self.product == null) {
                    self.order.products.filter((product) => product.latest_artwork && product.latest_artwork.attach_link).forEach((product) => {
                        self.artworks.push(product.latest_artwork);
                    });
                }
            }

            self.selectedCustomers = [];
            if(self.order.customer) {
                let html = '<div>' + self.order.customer.company_name + '</div>';
                let text = '<div>' + self.order.customer.company_name + '</div>';
                let default_contacts = self.order.customer.customer_contacts.filter((x) => x.default_contact == 1);
                if(default_contacts.length) {
                    html = '<div>' + default_contacts[0].contact_name + ' ('+default_contacts[0].email+')</div>' + '<div class="short_text">Company:'+ self.order.customer.company_name + '</div>';
                    text = '<div>' + self.order.customer.company_name + ' ('+default_contacts[0].email+')</div>';
                } else if(self.order.customer.customer_contacts.length) {
                    html = '<div>' + self.order.customer.customer_contacts[0].contact_name + ' ('+self.order.customer.customer_contacts[0].email+')</div>' + '<div class="short_text">Company:'+ self.order.customer.company_name + '</div>';
                    text = '<div>' + self.order.customer.company_name + ' ('+self.order.customer.customer_contacts[0].email+')</div>';
                }
                self.selectedCustomers.push({
                    id: self.order.customer.id,
                    sales_rep_id: self.order.customer.sales_rep_id,
                    text: text,
                    name: text,
                    html: html,
                });
            }
        });
    },
    data() {
        return {
            submitted: false,
            isCC: false,
            media_ids: [],
            cc: [],
            isBCC: false,
            bcc: [],
            subject: null,
            message_body: "Hello, <p>Please Enter Message</p>",
            adminUser: null,
            smtp_user: null,
            customer_files: [],
            artworks: [],
            selectedCustomers: [],
            dropzoneOptions: {
                url: window.route('medias.store'),
                thumbnailWidth: 150,
                maxFilesize: 2048, //mb
                maxFiles: 5,
                addRemoveLinks: false,
                chunking: false,
                //chunkSize: 500, // bytes
                headers: {
                    "Authorization": 'Bearer ' + localStorage.getItem('token'),
                    "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]").content
                }
            },
            editorConfigMin: {
                toolbar: [
                    [ 'Source', '-', 'Bold', 'Italic' ],
                    [ 'Styles', 'Format', 'Font', 'FontSize' ],
                ]
            }
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
            'setNewPurchaseOrder'
        ]),
        customerSelected(event){
            this.selectedCustomers = event;
        },
        removeArtwork(artwork1, artwork1Index){
            this.artworks.splice(artwork1Index, 1);
        },
        getSendToCustomerSettings() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('orders.sendToCustomer.settings'), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.adminUser = data.data.adminUser;
                        this.smtp_user = data.data.smtp_user;
                        this.subject = data.data.so_send_to_customer_title;
                        this.message_body = data.data.so_send_to_customer_body;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        sendToCustomer() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('orders.sendArtworksToCustomer', {id: this.order.id}), {
                subject: this.subject,
                cc: this.cc,
                bcc: this.bcc,
                message_body: this.message_body,
                media_ids: this.media_ids,
                isCC: this.isCC,
                isBCC: this.isBCC,
                product_id: this.product ? this.product.id : null,
                artwork_id: this.artwork ? this.artwork.id : null,
                is_one_artwork_for_all: this.is_one_artwork_for_all,
                artworks: this.artworks,
                selectedCustomers: this.selectedCustomers
            }, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.$emit('sendProductArtworkToCustomerEvent', data.data);
                        self.setSuccessMessage(data.message);
                        $('#sendProductArtworkToCustomer').modal('hide');
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        deleteAttachFile(index, item){
            this.$refs.sendArtToCustomerDropzone.removeFile(item.file);
            this.customer_files.splice(index, 1);
            this.media_ids.splice(index, 1);
        },
        afterUploadComplete(file, response) {
            //this.media_id = response.data.media.id;
            this.customer_files.push({
                id: response.data.media.id,
                name: response.data.media.filename,
                file_size: response.data.media.file_size,
                src: response.data.url,
                file_type: response.data.media.file_type,
                file_ext: response.data.media.file_ext,
                original_file_name: response.data.media.original_file_name,
                file: file
            });
            this.media_ids.push(response.data.media.id);
        },
        toggleCC(){
          this.isCC = !this.isCC;
            if(!this.isCC) {
                this.cc = [];
            }
        },
        toggleBCC(){
            this.isBCC = !this.isBCC;
            if(!this.isBCC) {
                this.bcc = [];
            }
        },
        download(artwork) {
            let url = window.route('medias.download', {
                path: 'so_attachments',
                id: this.order.id,
                name: artwork.attach_link,
                pdf_to_image: 0
            });

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(url, {
                responseType: "blob",
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    self.setLoading(false);
                    // Service that handles ajax call
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("target", "_blank");
                    link.setAttribute("download", artwork.attach_link);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },

    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading',
        ])
    }
}
</script>

<style scoped>

</style>
